export * from './data-cy'
export * from './mixpanel'

export enum Theme {
  Dark = 'dark',
  Light = 'light'
}

export enum PieChart {
  Vote = 'vote',
  Deposit = 'deposit'
}

export enum MenuItemType {
  Link = 'link',
  Dropdown = 'dropdown'
}

export enum StatusKey {
  ProposalSubmitStatus = 'ProposalSubmitStatus'
}

export enum ValidatorStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export enum NoticeBanner {
  UpcomingChainUpgrade = 'upcoming-chain-upgrade'
}

export enum WalletModalType {
  All = 'all',
  Ledger = 'ledger',
  Trezor = 'trezor'
}

export enum StakingStatus {
  Unbonding = 'unbonding',
  Redelegation = 'redelegation'
}

export enum StreamType {
  Bids = 'bids',
  Blocks = 'blocks',
  Transactions = 'transactions'
}

export enum ValidatorUptimeStatus {
  Missed = 'missed',
  Signed = 'signed',
  Proposed = 'proposed'
}

export enum ProgressBarType {
  Gray = 'gray',
  Accent = 'accent',
  Primary = 'primary',
  Gradient = 'gradient'
}

export enum StakingModalView {
  Amount = 'amount',
  Confirm = 'confirm',
  Success = 'success',
  Validator = 'validator'
}

export enum Interval {
  All = 'all',
  Day = 'day',
  Week = 'week',
  Year = 'year',
  Month = 'month',
  ThreeMonths = 'three-months'
}

export enum DappCategory {
  Dex = 'DEX',
  DeFi = 'DeFi',
  Tools = 'Tools',
  NFTFi = 'NFTFi',
  SocialFi = 'SocialFi',
  AllCategory = 'All Category'
}

export enum StakingSortType {
  Uptime = 'uptime',
  Validator = 'validator',
  Commission = 'commission',
  VotingPower = 'votingPower',
  StakedAmount = 'stakedAmount'
}

export enum EventBus {
  Unbond = 'Unbond',
  Delegate = 'Delegate',
  Redelegate = 'Re-delegate',
  AuctionTabChange = 'AuctionTabChange',
  ProposalQuoteChange = 'ProposalQuoteChange'
}

export enum ProposalType {
  TextProposal = 'text-proposal',
  SpotMarketLaunch = 'spot-market-launch',
  PerpetualMarketLaunch = 'perpetual-market-launch',
  InstantSpotMarketLaunch = 'instant-spot-market-launch'
}

export enum AmplitudeEvents {
  Vote = 'Vote',
  Login = 'Login',
  Claim = 'Claim',
  Unbond = 'Unbond',
  Delegate = 'Delegate',
  PlaceBid = 'Place-bid',
  ClaimAll = 'Claim All',
  Redelegate = 'Re-delegate',
  ConnectClicked = 'Connect Clicked',
  WalletSelected = 'Wallet Selected',
  KadoBannerClicked = 'Kado Banner Clicked'
}

export enum TableHeaderType {
  // insurance funds
  Funds = 'funds',
  // staking validators
  Uptime = 'Uptime',
  Market = 'market',
  Rewards = 'Rewards',
  Validator = 'validator',
  Commission = 'commission',
  VotingPower = 'votingPower',

  StakedAmount = 'stakedAmount',
  MyPoolTokens = 'myPoolTokens',
  CompletionTime = 'completionTime',
  TotalPoolTokens = 'totalPoolTokens',
  MyOwnershipPercentage = 'myOwnershipPercentage'
}

export enum Modal {
  Send = 'Send',
  Terms = 'Terms',
  Unbond = 'unbond',
  QrCode = 'qrcode',
  WrapInj = 'WrapInj',
  DevMode = 'devMode',
  UnwrapInj = 'UnwrapInj',
  ReDelegate = 're-delegate',
  GetStarted = 'get-started',
  GeoRestricted = 'GeoRestricted',
  RedeemToCw20 = 'redeem-to-cw20',
  WalletConnect = 'wallet-connect',
  TokenSelector = 'token-selector',
  ConvertToBank = 'convert-to-bank',
  AuctionDetails = 'auction-details',
  AuctionRewards = 'auction-rewards',
  CreateSubDenom = 'create-sub-denom',
  DelegationWarning = 'delegation-warning',
  AuctionHowItWorks = 'auction-how-it-works',
  DelegateToValidator = 'delegate-to-validator',
  InsufficientInjForGas = 'insufficient-inj-for-gas',
  MintTokenFactorySupply = 'mint-token-factory-supply',
  BurnTokenFactorySupply = 'burn-token-factory-supply',
  UpdateTokenFactoryMetadata = 'update-token-factory-metadata',
  SecureAuctionSpotConfirmation = 'secure-auction-spot-confirmation'
}
